import { render, staticRenderFns } from "./slack-integration-accordion.vue?vue&type=template&id=f0c039da&"
import script from "./slack-integration-accordion.vue?vue&type=script&lang=ts&"
export * from "./slack-integration-accordion.vue?vue&type=script&lang=ts&"
import style0 from "./slack-integration-accordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports